/**
 * Avatar-komponentin puhdas logiikka (AB-WP6.7): nimestä johdetut initiaalit
 * (kuvan fallback) ja deterministinen taustaväri (sama nimi → sama väri).
 * Ei DOMia — runtime.ts:n wireAvatar + applySlotToDom käyttävät näitä.
 */

/** Deterministinen väripaletti initiaalifallbackille. */
const AVATAR_COLORS = [
  '#2563eb', '#16a34a', '#d97706', '#dc2626', '#7c3aed',
  '#0891b2', '#db2777', '#65a30d', '#0d9488', '#4f46e5',
];

/**
 * Nimen initiaalit: "Alice Bob" → "AB" (etu- + sukunimen alkukirjain),
 * yksi sana → kaksi ensimmäistä kirjainta, tyhjä → "?".
 */
export function initialsOf(name: string): string {
  const parts = (name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

/** Vakaa taustaväri nimestä (sama nimi → sama väri; djb2-tyyppinen hash). */
export function colorFromName(name: string): string {
  const s = name || '';
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = (h * 31 + s.charCodeAt(i)) >>> 0;
  }
  return AVATAR_COLORS[h % AVATAR_COLORS.length];
}
